import Vuex from 'vuex';
import { createLogger } from 'vuex';

import auth from './auth';
import locker from './locker';
import log from './log';
import organization from "./organization";
import password from './password';
import region from './region';
import user from './user';
import model from './model';
import cell from './cell';
import cell_size from './cell_size';
import city from './city';
import country from './country';
import control_unit from './control_unit';
import address from './address';
import district from './district';
import statistic from "./statistic";
import firmware from "./firmware";
import order from "./order";
import billing from "./billing";
import maintenance from "./maintenance";


const debug = process.env.NODE_ENV !== 'production';


export default new Vuex.Store({
    modules: {
        address,
        auth,
        locker,
        log,
        organization,
        password,
        user,
        model,
        cell,
        cell_size,
        city,
        country,
        district,
        control_unit,
        region,
        statistic,
        firmware,
        order,
        billing,
        maintenance,
    },
    strict: debug,
    plugins: debug ? [createLogger()] : [],
});
